import { Expand } from "@jewlr/storybook/animate"
import { Button } from "@jewlr/storybook/core"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import withFilters from "areas/collection/hoc/with-filters"
import { useNavigation } from "helpers/use-navigation"

const FilterDropdown = styled(Expand)`
  background-color: white;
  box-shadow: 0 2px 4px 0 ${(props) => props.theme.colors.grey10};
  margin: 0;
  padding: 8px 16px;
  position: absolute;
  right: 0;
  text-align: right;
  text-transform: capitalize;
  width: 200px;
  z-index: 2;
  ${({ theme }) => theme.mediaQueries.desktop`
    left: auto;
    right: 0;
    padding: 8px 10px;
    text-align: left;
  `}
`
const DropdownItem = styled(Button).attrs({
  variant: "text",
})`
  display: inline-block;
  font-size: 16px;
  letter-spacing: 0.5px;
  text-align: right;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.tablet`
    border-bottom: ${theme.collectionSort.border};
    padding: 8px 16px;
    text-align: left;
    :last-child {
      border-bottom: none;
    }
  `};
  &:hover {
    text-decoration: underline;
  }
  ${(props) =>
    props.active &&
    `
      color: ${props.theme.colors.primary};
      font-weight: bold;
  `}
`

const SortItem = withFilters(({ active, option, toggleSort, updateSort }) => {
  const keyboardProps = useNavigation({
    onEscape: () => toggleSort(false),
  })

  return (
    <DropdownItem
      active={active}
      aria-selected={active}
      data-cy={`collection-sort-option-${option.sort}`}
      onClick={() => updateSort(option.sort)}
      role="option"
      tabIndex={active ? 0 : -1}
      {...keyboardProps}
    >
      {option.label}
    </DropdownItem>
  )
})

SortItem.propTypes = {
  active: PropTypes.bool,
  option: PropTypes.object,
  toggleSort: PropTypes.func,
  updateSort: PropTypes.func,
}

const SortFilter = ({ sortMenu }) => {
  return (
    <FocusScope autoFocus restoreFocus>
      <FilterDropdown
        aria-labelledby="collection-sort-button"
        id="collection-sort-menu"
        role="listbox"
        show
      >
        {sortMenu.options.map((option) => (
          <SortItem
            active={sortMenu.current_sort === option.sort}
            key={`sort${option.sort}`}
            option={option}
          />
        ))}
      </FilterDropdown>
    </FocusScope>
  )
}

SortFilter.propTypes = {
  sortMenu: PropTypes.object,
}

export default withFilters(SortFilter)
